import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { ConsumptionsView } from "@containers/admin/ConsumptionsView";

const ConsumptionsPage = () => {
    return (
        <AuthenticatedLayout adminPage activeMenuItem="consumptions">
            <ConsumptionsView maxW={400} />
        </AuthenticatedLayout>
    );
}

export default ConsumptionsPage;